import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { COMPANY_TYPES } from '../../../../utils/common'
import { SCORE_TYPE } from '../../../common/header/companyInfo/constant'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { Upgrade } from '../../../industry/industryAnalysis/score/Upgrade'
import { selectPeerOrganizationIds } from '../../store/slice'
import classes from './index.module.scss'
import { changeActiveTab, selectActiveTab } from './store/slice'
import { getScore } from './store/thunk'
import { CreditRiskScore } from './tabs/CreditRiskScore'
import { PerformanceScore } from './tabs/PerformanceScore'

const TABS = [
  {
    label: 'companyAnalysis.peerAnalysis.CREDIT_RISK_SCORE',
    key: SCORE_TYPE.CREDIT_RISK,
  },
  {
    label: 'companyAnalysis.peerAnalysis.PERFORMANCE_SCORE',
    key: SCORE_TYPE.PERFORMANCE,
  },
]

export const Score = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const activeTab = useSelector(selectActiveTab)
  const locale = useSelector((state) => state.i18n.locale)
  const peerOrganizationIds = useSelector(selectPeerOrganizationIds)
  const companyInfo = useSelector(selectCompanyInfo)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const isHidden = [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
  ].includes(companyInfo.companyType)

  useEffect(() => {
    dispatch(getScore({ organizationId, peerOrganizationIds }))
  }, [locale, peerOrganizationIds])

  const onClickTab = (item) => {
    dispatch(changeActiveTab(item))
  }

  const renderContent = () => {
    return activeTab === SCORE_TYPE.CREDIT_RISK ? (
      <CreditRiskScore />
    ) : (
      <PerformanceScore />
    )
  }

  return (
    <Panel
      isI18n
      height={isHidden ? 'auto' : 556}
      label="companyAnalysis.peerAnalysis.SCORE"
    >
      <div className="flexColumn h100">
        <Element
          className={classes.tabContainer}
          style={{
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: '#B5CEF8',
          }}
        >
          <div className={classes.tabs}>
            {TABS.map((tab) => (
              <Element
                key={tab.key}
                className={classes.tabItem}
                style={{
                  color: tab.key === activeTab ? '#FFFFFF' : '#191D25',
                  backgroundColor:
                    tab.key === activeTab ? '#2C73E8' : '#F3F3F3',
                  marginRight: 4,
                  padding: '2px 8px',
                }}
                onClick={() => onClickTab(tab.key)}
              >
                <Translate value={tab.label} />
              </Element>
            ))}
          </div>
        </Element>

        {isHidden ? (
          <Upgrade text={'companyAnalysis.industryAnalysis.UPGRADE_DESC'} />
        ) : (
          <div className="py1 flex1">{renderContent()}</div>
        )}
      </div>
    </Panel>
  )
}
